export default __webpack_public_path__ + "static/media/swap.8e3da68c.svg";